import module from 'finanzas/module.js'

function FinanzasReporteFacturasService ($api, $export) {
  this.obtenerEmpresasFacturacion = function () {
    return $api.get('kendu/finanzas/reportefacturas/empresas')
  }

  this.obtenerReporte = function (start, end, ids_empresas, estado) {
    return $api.get('/kendu/finanzas/reportefacturas', {
      start: start.toYMD(),
      end: end.toYMD(),
      ids_empresas: ids_empresas,
      estado: estado,
    })
  }

  this.exportarXLS = function (data, archivo) {
    $api.get('kendu/finanzas/reportefacturas/camposfacturacion')
      .then(function (campos) {
        var encabezados = [],
          pages = [],
          datosnuevos = [],
          nombre = 'Facturas'

        campos.forEach(function (item) {
          encabezados.push({
            label: item.descripcion,
            format: {
              align: 'left',
              width: 40,
            },
          })
        })

        encabezados.push({
          label: 'Concepto de Factura',
          format: {
            align: 'left',
            width: 120,
          },
        })

        data.forEach(function (item) {
          var aux = {}
          campos.forEach(function (campo) {
            aux[campo.campo] = item[campo.campo]
          })
          aux.concepto = item.concepto
          datosnuevos.push(aux)
        })
        var activas = [], canceladas = []
        activas = datosnuevos.filter(function (item) {
          return item.estado == '1'
        })
        canceladas = datosnuevos.filter(function (item) {
          return item.estado == '0'
        })
        // pages.push(new Page(datosnuevos, encabezados, nombre))
        if (activas.length > 0)
          pages.push(new Page(activas, encabezados, nombre))
        if (canceladas.length > 0)
          pages.push(new Page(canceladas, encabezados, 'CANCELADAS'))

        $export.excel(archivo, pages)
      })
  }

  function Page (data, encabezados, nombre) {
    // columanas = generarColumnas
    return {
      name: nombre,
      columns: encabezados,
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'A8',
      },
      data: data,
    }
  }
}

module.service('FinanzasReporteFacturas', FinanzasReporteFacturasService)



// WEBPACK FOOTER //
// ./src/finanzas/services/FinanzasReporteFacturas.js